import { overflowCssPropertyName } from './consts';

export const removeVisibleClassWhenEndAnimation = (event: TransitionEvent) => {
  event.stopPropagation();

  const subHeader = event.currentTarget as HTMLDivElement;
  const navItem = subHeader.closest<HTMLElement>('.kf-o-header__navigation__item');
  const propertyName = event.propertyName;
  const navItemOpen = navItem?.closest<HTMLElement>('.kf-o-header--open-sub-nav');

  if (!navItem || propertyName !== 'height' || !!navItemOpen) {
    return;
  }

  navItem.classList.remove('visible');

  subHeader.removeEventListener('transitionend', removeVisibleClassWhenEndAnimation);
};

export const setOverflowBody = (hidden?: boolean) => {
  if (hidden) {
    document.body.style.setProperty(overflowCssPropertyName, 'hidden');
  } else {
    document.body.style.removeProperty(overflowCssPropertyName);
  }
};

export const setOverflowElement = (element?: HTMLElement | null, hidden?: boolean) => {
  if (!element) {
    return;
  }

  if (hidden) {
    element.classList.add('no-scroll');
  } else {
    element.classList.remove('no-scroll');
  }
};
